// 3rd Party Libs
import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.css';

// Common Components
import './components/banner';
import './components/nav';
import './components/footer';

import './modules/tab_navigation';

import '../sass/services.scss';

// Import PDFS
import '../docs/services.pdf';

import '../docs/packages/easterncape.pdf';
import '../docs/packages/gau_limp.pdf';
import '../docs/packages/kzn.pdf';
import '../docs/packages/mpumalanga.pdf';
import '../docs/packages/northwest.pdf';
import '../docs/packages/westerncape.pdf';

// Modules
import './modules/common-images';
import './modules/mobile-navbar';
import './modules/nav';

import { stichImageToBGElement, stichImageToDomElement } from './modules/image-helper';
import { packages } from './modules/packages';

// Images
import slider_one from '../images/unsplash/boat-in-ocean.jpg';
import slider_two from '../images/slider/glass-pool.jpg';
import slider_three from '../images/slider/3.jpg';
import slider_four from '../images/slider/4.jpg';
import unleash_your_paradise from '../images/sections/unleash_your_paradise.jpg';
import discover from '../images/sections/discover.jpg';
import book from '../images/sections/book.jpg';
import packBags from '../images/sections/pack-bags.jpg';

const images = [{
        id: 'slider_1',
        img: slider_one,
        bgImage: true,
    },
    {
        id: 'slider_2',
        img: slider_two,
        bgImage: true,
    },
    {
        id: 'slider_3',
        img: slider_three,
        bgImage: true,
    },
    {
        id: 'slider_4',
        img: slider_four,
        bgImage: true,
    },
    {
        id: 'img-1',
        img: discover,
        bgImage: false,
    },
    {
        id: 'img-2',
        img: book,
        bgImage: false,
    },
    {
        id: 'img-3',
        img: packBags,
        bgImage: false,
    },
    {
        id: 'img-4',
        img: slider_four,
        bgImage: true,
    },
    {
        id: 'img-5',
        img: unleash_your_paradise,
        bgImage: false,
    },
    {
        id: 'img-6',
        img: slider_one,
        bgImage: false,
    },
    {
        id: 'img-7',
        img: slider_three,
        bgImage: true,
    },
    {
        id: 'img-8',
        img: slider_two,
        bgImage: false,
    },
];

images.forEach(obj => {
    if (obj.bgImage == true) {
        stichImageToBGElement(obj.id, obj.img);
    }

    stichImageToDomElement(obj.id, obj.img);
});


new Swiper(".mySwiper-2", {
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

window.addEventListener('load', () => {
    // var packagesOutput = $('#western-cape > .tab-pane__inner');

    packages.forEach(obj => {
        const { name, price, province, pdf, images, audience, location, description } = obj;
        const id = name.replace(/\s+/g, '-').toLowerCase();

        var packagesOutput = $(`#${province} > .tab-pane__inner`);
        $(packagesOutput).append(
            `
<div class="card" id="${id}">
    <div class="images-container">   
        <div id="carouselExampleIndicators-${id}" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators carousel-indicators-${id}"></ol>
            <div class="carousel-inner carousel-inner-${id}"></div>

            <a class="carousel-control-prev" href="#carouselExampleIndicators-${id}" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators-${id}" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
    <div class="card__content">
        <h3 class="card-title">${name}</h3>
        <p class="card-description">${description}</p>

        <div class="card-info">
            <p class="card-location">
                <span><i class="fas fa-map-marker-alt"></i></span>${location}
            </p>
            <p class="card-audience">
                <span><i class="fas fa-user-friends"></i></span>${audience}
            </p>
        </div>

        <div class="card__footer">
            <p class="card-price">FROM <span>R${price.value}</span> ${price.quanity}</p>
            <div class="card-btn-group">
                <a target="_blank" class="learn-more" href="${pdf}">
                    Learn more
                </a>
                <a class="book-now" href="./contact.html">
                    Book now
                </a>
            </div>
        </div>
    </div>
</div>
            `
        );

        for (let i = 0; i < images.length; i++) {
            const img = images[i];
            const image = images.length == 0 ? 'https://via.placeholder.com/150' : img;

            $(`.carousel-inner-${id}`).append(
                `
                    <div class="carousel-item">
                        <img loading="lazy" class="" src="${image}" alt="First slide">
                    </div>
                `
            );

            $(`.carousel-indicators-${id}`).append(
                `<li data-target="#carouselExampleIndicators-${id}" data-slide-to="${i}"></li>`
            );
        };

        $(`.carousel-inner-${id}`).find('>:first-child').addClass('active');
        $(`.carousel-indicators-${id}`).find('>:first-child').addClass('active');
    });
});

new Swiper(`.images-carousel `, {
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});